import cs from './message-cs'
import en from './message-en'
import enAu from './message-en-au'
import enNz from './message-en-nz'
import enCa from './message-en-ca'
import enUs from './message-en-us'
import enSys from './message-en-sys'
import sk from './message-sk'
import tr from './message-tr'
import bg from './message-bg'
import fr from './message-fr'
import lt from './message-lt'
import id from './message-id'
import he from './message-he'
import fi from './message-fi'
import hu from './message-hu'
import hi from './message-hi'
import ro from './message-ro'
import ne from './message-ne'
import nl from './message-nl'
import sl from './message-sl'
import lv from './message-lv'
import ta from './message-ta'
import uk from './message-uk'
import frCa from './message-fr-ca'
import ja from './message-ja'
import zhHans from './message-zh-hans'
import zhHant from './message-zh-hant'
import de from './message-de'
import arJo from './message-ar-jo'

export default {
  'en-sys': {
    ...enSys
  },
  'en-gb': {
    ...en
  },
  'en-au': {
    ...enAu
  },
  'en-nz': {
    ...enNz
  },
  'en-ca': {
    ...enCa
  },
  'en-us': {
    ...enUs
  },
  cs: {
    ...cs
  },
  sk: {
    ...sk
  },
  sl: {
    ...sl
  },
  tr: {
    ...tr
  },
  bg: {
    ...bg
  },
  ro: {
    ...ro
  },
  ne: {
    ...ne
  },
  hu: {
    ...hu
  },
  hi: {
    ...hi
  },
  he: {
    ...he
  },
  nl: {
    ...nl
  },
  fr: {
    ...fr
  },
  lt: {
    ...lt
  },
  lv: {
    ...lv
  },
  id: {
    ...id
  },
  ar: {
    ...arJo
  },
  de: {
    ...de
  },
  ja: {
    ...ja
  },
  ta: {
    ...ta
  },
  uk: {
    ...uk
  },
  fi: {
    ...fi
  },
  'fr-ca': {
    ...frCa
  },
  'zh-hans': {
    ...zhHans
  },
  'zh-hant': {
    ...zhHant
  }
}
